package com.merkost.handpass.api.dto.storage

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UploadUrlResponse(
    @SerialName("upload_url") val uploadUrl: String,
    @SerialName("storage_key") val storageKey: String,
    @SerialName("expires_in") val expiresIn: Int
)
